import React, { useEffect, useState } from "react";
import uiConfig from "../../config/uiConfig";

import { Box, Button, Typography } from "@mui/material";

import { useMsal } from "@azure/msal-react";

import { loginRequest } from "../../config/msalConfig";

// Microsoft's four-color square glyph, drawn with plain boxes (no brand SVG asset in the repo).
function MicrosoftLogo() {
  const squareStyle = { width: 9, height: 9 };
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1px", width: 19, height: 19, mr: 1.5, flexShrink: 0 }}>
      <Box sx={{ ...squareStyle, bgcolor: "#F25022" }} />
      <Box sx={{ ...squareStyle, bgcolor: "#7FBA00" }} />
      <Box sx={{ ...squareStyle, bgcolor: "#00A4EF" }} />
      <Box sx={{ ...squareStyle, bgcolor: "#FFB900" }} />
    </Box>
  );
}

function LoginButton() {
  const { instance, accounts } = useMsal();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (accounts.length > 0) {
      console.log("Existing user:", accounts[0]);
    }
  }, [accounts]);


  const handleLogin = async () => {
    setLoading(true);
    setError(null);
 
    try {
      // Use loginRedirect - more reliable than popup for B2C
      await instance.loginRedirect(loginRequest);
      // Note: page will navigate away to Azure AD - code below won't run
    } catch (err) {
      console.error('❌ Login error:', err);
      if (err.errorCode === 'interaction_in_progress') {
        setError('Another login attempt is in progress. Please wait.');
      } else {
        setError(`Login failed: ${err.errorMessage || err.message || 'Unknown error'}`);
      }
      setLoading(false);
    }
  };
 
  // Navigate to dashboard once authenticated
 

  return (
    <>
      <Button
        fullWidth
        disabled={loading}
        onClick={handleLogin}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#ffffff",
          color: uiConfig.buttonColor,
          textTransform: "none",
          fontWeight: 700,
          fontSize: 15,
          px: 3,
          py: 1.4,
          borderRadius: 2,
          boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
          "&:hover": {
            background: "#f8fafc",
            transform: "translateY(-2px)",
            boxShadow: "0 12px 30px rgba(0,0,0,0.3)",
          },
          "&:active": { transform: "translateY(0)" },
        }}
      >
        <MicrosoftLogo />
        {loading ? "Signing in..." : "Sign In with Microsoft Account"}
      </Button>

      {error && (
        <Typography sx={{ color: "#fecaca", fontSize: 13, mt: 2 }}>
          {error}
        </Typography>
      )}
    </>
  );
}

export default LoginButton;
